import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  StyleSheet,
  Text,
  TextInput,
  View,
} from './components/base_components';
import { useBusy, BusyOverlay } from './components/busy_component';

import Breadcrumb from './components/breadcrumb';
import ProgressSpinner from './components/progress_spinner';
import OrgTabBar from './components/org_tab_bar';
import StandardBoxList from './components/standard_box_list';
import TextButton from './components/buttons/text_button';

import AppStore from './stores/app_store';
import OrgStore from './stores/org_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  orgAppListScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  spinner: {
    margin: '3rem',
    alignSelf: 'center',
  },
  tabBar: {
    marginLeft: '2.2rem',
    marginRight: '2.2rem',
  },
  dialog: {
    marginLeft: '2rem',
    marginBottom: '2rem',
    flexDirection: 'column',
  },
  text: {
    marginTop: '1em',
    fontSize: '1.5em',
  },
  input: {
    alignSelf: 'stretch',
    maxWidth: '40rem',
    marginTop: '1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    color: '#555',
    fontSize: '1.5rem',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: '#ccc',
    backgroundColor: '#f5f5f5',
  },
  button: {
    marginTop: '1rem',
    alignSelf: 'flex-start',
  },
});

export default function OrgAppListScreen() {
  const org_id = UserStore.useOrg()?.org_id;
  const org = OrgStore.useOrg(org_id);
  const list = AppStore.useList(org_id);
  const [is_busy, setBusy, clearBusy] = useBusy();
  const [app_name, setAppName] = React.useState('');
  const navigate = useNavigate();

  React.useEffect(() => {
    OrgStore.fetch(org_id);
    AppStore.fetch(org_id);
  }, [org_id]);

  function _onCreatePress() {
    if (app_name && setBusy()) {
      AppStore.createApp({ org_id, app_name }, (err, app_id) => {
        clearBusy();
        if (err === 409) {
          window.alert('Name already in use, please try again.');
        } else if (err) {
          window.alert('Create failed, please try again.');
        } else {
          navigate(`/org/app/${app_id}`);
        }
      });
    }
  }

  let content: any = null;
  if (!org || !list) {
    content = <ProgressSpinner style={styles.spinner} color='#555' />;
  } else {
    const rows = list.map((app) => ({
      url: `/org/app/${app.app_id}`,
      list: [app.app_name, app.is_disabled ? 'Disabled' : 'Enabled'],
    }));
    let empty: any = null;
    if (rows.length === 0) {
      empty = (
        <View style={styles.dialog}>
          <Text style={styles.text}>No apps found.</Text>
        </View>
      );
    }

    content = (
      <>
        <Breadcrumb list={[{ text: org?.org_name, url: `/org` }, 'Apps']} />
        <OrgTabBar style={styles.tabBar} />
        <StandardBoxList
          title='App'
          headers={['App Name', 'Status']}
          rows={rows}
        >
          {empty}
        </StandardBoxList>
        <StandardBoxList title='Add App'>
          <View style={styles.dialog}>
            <Text style={styles.text}>
              Create a new app for your organization.
            </Text>
            <TextInput
              style={styles.input}
              placeholder='New App Name'
              value={app_name}
              onChangeText={setAppName}
            />
            <TextButton
              style={styles.button}
              text='Create App'
              onPress={_onCreatePress}
            />
          </View>
        </StandardBoxList>
        <BusyOverlay isBusy={is_busy} />
      </>
    );
  }
  return <View style={styles.orgAppListScreen}>{content}</View>;
}
